export const SET_MODULE_LOADING = `modules/set_module_loading`;
export const SET_MODULE = `modules/set_module`;



// WEBPACK FOOTER //
// ./src/store/base/modules/types.js